<div class="card md:p-8 shadow-none" style="    width: 100%;    height: 100%; ">
    <div class="top-content md:w-8 my-3">
        <h1 class="font-bold text-gray-700">{{ 'sipo.signature-standards' | translate }}</h1>
        <!--        <span class="text-gray-500">{{ 'sipo.manage-e-signature' | translate }}</span>-->
    </div>
    <!-- card-0 begin -->
    <!--    <div class="custom-card-1 shadow-2 md:flex justify-content-between px-4 py-5 md:w-8">-->
    <!--        <div class="md:w-3 flex md:flex-column">-->
    <!--            <div class="md:mb-1 font-bold text-gray-700 w-6 md:w-full mr-1 md:mr-0">{{ 'sipo.evidence' | translate }}: {{ 'sipo.high' | translate }}</div>-->
    <!--            <div class="md:mt-1 text-gray-500 underline w-6 md:w-full ml-1 md:ml-0">{{ 'sipo.what-does-that-mean' | translate }}</div>-->
    <!--        </div>-->
    <!--        <div class="md:w-9 flex bg-gray-100 custom-border-pill mt-2 md:mt-0">-->
    <!--            <div class="bg-primary w-9 custom-border-pill flex justify-content-end align-items-center pr-3">-->
    <!--                <span class="font-bold text-gray-200">{{ 'sipo.high' | translate }}</span>-->
    <!--            </div>-->
    <!--            <div class="w-3 custom-border-pill flex justify-content-end align-items-center pr-3 text-gray-300">-->
    <!--                <span class="font-bold">{{ 'sipo.maximum' | translate }}</span>-->
    <!--            </div>-->
    <!--        </div>-->
    <!--    </div>-->
    <!-- card-0 end -->
    <div class="mid-content px-4 pt-4 pb-2 md:w-8">
        <span class="font-bold">{{ 'sipo.sign-with' | translate }}:</span>
    </div>
    <!-- card-1 begin -->
    <div class="custom-card-2 shadow-2 md:w-8 overflow-hidden">
        <div class="flex justify-content-between align-items-center p-2 border-bottom-1 surface-border w-full">
            <div class="my-2 flex align-items-center w-6">
                <span class="px-1 py-2 w-5rem inline-block" [innerHTML]="'basic' | evidenceSvg"></span>
                <span class="font-bold ml-4">{{ 'sipo.basic' | translate }}</span>
            </div>
            <div class="flex-grow-1 flex ml-1 md:ml-0 w-5">
                <span class="text-gray-500">{{ 'sipo.simple-e-signature.long' | translate }}</span>
            </div>
            <div class="text-gray-500 cursor-pointer w-1 flex justify-content-end pr-3" (click)="toggleStatus(1)">
                <i class="pi pi-chevron-down" *ngIf="!isFirstExpanded"></i>
                <i class="pi pi-chevron-up" *ngIf="isFirstExpanded"></i>
            </div>
        </div>
        <div class="accordion-content" [ngClass]="{'expanded-content': isFirstExpanded}">
            <div class="p-4 w-full flex align-items-center border-bottom-1 surface-border">

                {{'sipo.simple-e-signature.description'|translate}}

            </div>
            <div class="p-4 w-full flex align-items-center border-bottom-1 surface-border">
                <div class="w-6 font-bold text-gray-500">{{ 'sipo.checked-by' | translate }}</div>
                <div class="w-6 text-gray-500">{{ whoChecked }}</div>
            </div>
            <div class="p-4 w-full flex align-items-center">
                <div class="w-6 font-bold text-gray-500">{{ 'sipo.certificate' | translate }}</div>
                <div class="w-6 text-gray-500">Imzaflow</div>
            </div>
        </div>
    </div>
    <!-- card-1 end -->
    <!-- card-2 begin -->
    <div class="custom-card-2 shadow-2 md:w-8 overflow-hidden my-3">
        <div class="flex justify-content-between align-items-center p-2 border-bottom-1 surface-border w-full">
            <div class="my-2 flex align-items-center w-6">
                <span class="px-1 py-2 w-5rem inline-block" [innerHTML]="'basiccert' | evidenceSvg"></span>
                <span class="font-bold ml-4">{{ 'sipo.basic' | translate }}
                    + {{ 'sipo.qualified-time-stamps' | translate }}</span>
            </div>
            <div class="flex-grow-1 flex ml-1 md:ml-0 w-5">
                <span class="text-gray-500">{{ 'sipo.simple-e-signature-2.long' | translate }}</span>
            </div>
            <div class="text-gray-500 cursor-pointer w-1 flex justify-content-end pr-3" (click)="toggleStatus(2)">
                <i class="pi pi-chevron-down" *ngIf="!isSecondExpanded"></i>
                <i class="pi pi-chevron-up" *ngIf="isSecondExpanded"></i>
            </div>
        </div>
        <div class="accordion-content" [ngClass]="{'expanded-content': isSecondExpanded}">
            <div *ngIf="userSubscription.plan === 'Starter'"
                class="w-full flex align-items-center justify-content-between p-2 text-white font-italic font-semibold bg-red-400">
                <div class="flex align-items-center">
                    <i class="pi pi-exclamation-circle mr-2"></i>
                    <span>{{'sipo.plan-not-allow-signature-type' | translate}}</span>
                </div>
                <button class="border-none bg-transparent border-round-lg p-1 text-white font-semibold cursor-pointer hover:underline" (click)="openPaymentComponent()">Upgrade</button>
            </div>
            <div class="p-4 w-full flex align-items-center border-bottom-1 surface-border">
                {{'sipo.simple-e-signature-2.description'|translate}}
            </div>
            <div class="p-4 w-full flex align-items-center border-bottom-1 surface-border">
                <div class="w-6 font-bold text-gray-500">{{ 'sipo.checked-by' | translate }}</div>
                <div class="w-6 text-gray-500">Wisekey</div>
            </div>
            <div class="p-4 w-full flex align-items-center">
                <div class="w-6 font-bold text-gray-500">{{ 'sipo.certificate' | translate }}</div>
                <div class="w-6 text-gray-500">Wisekey</div>
            </div>
        </div>
    </div>
    <!-- card-2 end -->
    <!-- card-3 begin -->
    <div class="custom-card-2 shadow-2 md:w-8 overflow-hidden my-3">
        <div class="flex justify-content-between align-items-center p-2 border-bottom-1 surface-border w-full">
            <div class="my-2 flex align-items-center w-6">
                <span class="px-1 py-2 w-5rem inline-block" [innerHTML]="'high' | evidenceSvg"></span>
                <span class="font-bold ml-4">{{ 'sipo.high' | translate }}</span>
            </div>
            <div class="flex-grow-1 flex ml-1 md:ml-0 w-5">
                <span class="text-gray-500">{{ 'sipo.advanced-e-signature.long' | translate }}</span>
            </div>
            <div class="text-gray-500 cursor-pointer w-1 flex justify-content-end pr-3" (click)="toggleStatus(3)">
                <i class="pi pi-chevron-down" *ngIf="!isThirdExpanded"></i>
                <i class="pi pi-chevron-up" *ngIf="isThirdExpanded"></i>
            </div>
        </div>
        <div class="accordion-content" [ngClass]="{'expanded-content': isThirdExpanded}">
            <div *ngIf="userSubscription.plan != 'Business'"
                 class="w-full flex align-items-center justify-content-between p-2 text-white font-italic font-semibold bg-red-400">
                <div class="flex align-items-center">
                    <i class="pi pi-exclamation-circle mr-2"></i>
                    <span>{{'sipo.plan-not-allow-signature-type' | translate}}.</span>
                </div>
                <button class="border-none bg-transparent border-round-lg p-1 text-white font-semibold cursor-pointer hover:underline" (click)="openPaymentComponent()">Upgrade</button>
            </div>
            <div class="p-4 w-full flex align-items-center border-bottom-1 surface-border">
                {{'sipo.advanced-e-signature.description'|translate}}
            </div>
            <div class="p-4 w-full flex align-items-center border-bottom-1 surface-border">
                <div class="w-6 font-bold text-gray-500">{{ 'sipo.checked-by' | translate }}</div>
                <div class="w-6 text-gray-500">SIGN8</div>
            </div>
            <div class="p-4 w-full flex align-items-center">
                <div class="w-6 font-bold text-gray-500">{{ 'sipo.certificate' | translate }}</div>
                <div class="w-6 text-gray-500">SIGN8</div>
            </div>
        </div>
    </div>
    <!--    card-3 end-->
    <!--    card-4 begin-->
    <div class="custom-card-4 shadow-2 md:w-8 my-3">
        <div class="md:flex justify-content-between align-items-center p-2">
            <div class="my-2 flex align-items-center w-6">
                <span class="px-1 py-2 w-5rem inline-block" [innerHTML]="'max' | evidenceSvg"></span>
                <span class="font-bold ml-4">{{ 'sipo.evidence-increase-qst' | translate }}</span>
            </div>

            <div class="flex-grow-1 flex ml-1 md:ml-0 w-5">
                <span class="text-gray-500">{{ 'sipo.evidence-increase-info' | translate }}</span>
            </div>
            <div class="text-gray-500 cursor-pointer w-1 flex justify-content-end pr-3" (click)="toggleStatus(4)">
                <i class="pi pi-chevron-down" *ngIf="!isQesExpanded"></i>
                <i class="pi pi-chevron-up" *ngIf="isQesExpanded"></i>
            </div>
        </div>
        <div class="accordion-content" [ngClass]="{'expanded-content': isQesExpanded}">
            <div *ngIf="userSubscription.plan != 'Business'"
                 class="w-full flex align-items-center justify-content-between p-2 text-white font-italic font-semibold bg-red-400">
                <div class="flex align-items-center">
                    <i class="pi pi-exclamation-circle mr-2"></i>
                    <span>{{'sipo.plan-not-allow-signature-type' | translate}}</span>
                </div>
                <button class="border-none bg-transparent border-round-lg p-1 text-white font-semibold cursor-pointer hover:underline" (click)="openPaymentComponent()">Upgrade</button>
            </div>
            <div class="p-4 w-full flex align-items-center border-bottom-1 surface-border">
                {{'sipo.qualified-e-signature.description'|translate}}
            </div>
            <div class="p-4 w-full flex align-items-center border-bottom-1 surface-border">
                <div class="w-6 font-bold text-gray-500">{{ 'sipo.checked-by' | translate }}</div>
                <div class="w-6 text-gray-500">SIGN8</div>
            </div>
            <div class="p-4 w-full flex align-items-center">
                <div class="w-6 font-bold text-gray-500">{{ 'sipo.certificate' | translate }}</div>
                <div class="w-6 text-gray-500">SIGN8</div>
            </div>
        </div>
    </div>
    <!--    card-4 end-->
</div>
